import React from 'react';
import { trackPixelEvent } from './MetaPixel';
export function Hero() {
  return <section className="bg-gradient-to-b from-blue-50 to-white pt-4 pb-6 md:py-16 px-4 md:px-6 text-center" data-id="element-69">
      <div className="max-w-3xl mx-auto" data-id="element-70">
        <p className="text-blue-600 font-semibold uppercase tracking-widest text-[10px] md:text-sm mb-1.5 md:mb-3" data-id="element-71">
          MegaPack Inglés 360 — Primaria y Secundaria
        </p>
        <h1 className="text-2xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-2 md:mb-4" data-id="element-72">
          TODO TU AÑO DE INGLÉS
          <br data-id="element-73" />
          <span className="text-blue-600" data-id="element-74">RESUELTO.</span>
        </h1>
        <p className="text-sm md:text-xl text-gray-600 mb-3 md:mb-6 leading-snug px-2 md:px-0" data-id="element-75">
          12 tomos completos para docentes de inglés de primaria y secundaria.
          180 actividades listas, alineadas al currículo argentino 2026.
        </p>
        <div className="flex justify-center mb-3 md:mb-8" data-id="element-76">
          <img src="https://cdn.magicpatterns.com/uploads/93NHYJDcxU4RYRJXsfahF1/94.png" alt="MegaPack Inglés 360 — Primaria y Secundaria: 12 cuadernillos + plan anual completo + bonus" className="w-40 md:w-auto md:max-w-lg h-auto" loading="eager" fetchPriority="high" decoding="async" width={1080} height={1300} data-id="element-77" />
        </div>
        <div className="flex flex-wrap justify-center gap-x-2 gap-y-1 md:gap-3 mb-3 md:mb-8 text-[11px] md:text-sm text-gray-500" data-id="element-78">
          <span data-id="element-79">✅ 100% PDF</span>
          <span data-id="element-80">✅ Acceso inmediato</span>
          <span data-id="element-81">✅ 🇦🇷 Currículo 2026</span>
          <span data-id="element-82">✅ Pre-A1 → B2</span>
        </div>
        <a href="#precios" onClick={() => trackPixelEvent('Lead', {
        content_name: 'Hero CTA',
        content_category: 'Pack de Inglés 360'
      })} className="inline-block bg-blue-600 hover:bg-blue-700 text-white text-sm md:text-lg font-bold py-3 md:py-4 px-6 md:px-10 rounded-full shadow-lg transition" data-id="element-83">
          📚 QUIERO MI PACK DE INGLÉS AHORA
        </a>
        <div className="flex justify-center gap-3 md:gap-6 mt-3 md:mt-4 text-[10px] md:text-xs text-gray-400" data-id="element-84">
          <span data-id="element-85">🛡️ Garantía 7 días</span>
          <span data-id="element-86">🔒 Pago seguro</span>
          <span data-id="element-87">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}